import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output } from "@angular/core";
import { AppService } from "@api";
import { HeaderEnum, RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { AlumnoEvaluacion } from "@modelo/global/AlumnoEvaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'evaluacion',
        templateUrl: './evaluacion.component.html',
        styleUrls: ['./evaluacion.component.scss']
    })

    export class EvaluacionComponent implements AfterViewInit{
        //@Input() entidad!: Evaluacion;
        @Input() metodoevaluacion!: number;
        @Input() alumno!: any;
        @Input() listapreguntas!: any;
        @Input() tipovisualizacioncompetenciacriterio!: number;
        @Input() tipovisualizacionrespuesta!: number;
        @Input() tipovisualizacionpregunta!: number;
        @Input() objobservacion!: any;
        @Input() prevista!: any;
        @Output() sinterminar = new EventEmitter();
        @Output() guardarrespuesta = new EventEmitter();
        @Output() terminado = new EventEmitter();
        @Output() comentario = new EventEmitter();
        @Output() salir = new EventEmitter();
        @Output() cambiarevaluacion = new EventEmitter();

        listaalumno:AlumnoEvaluacion;
        observacion: boolean = false;
        consulta!:boolean;
        formsValue: boolean = true;
        indexopcion: number = 0;
        conteoevaluador: number = 0;
        conteopregunta: number = 0;
        conteocriterio: number = 0;
        conteocompetencia: number = 0;
        competencia: any;
        criterio: any;
        pregunta: any;
        listapreguntasrelacion: any[] = [];

        public abierto!: boolean;
        public animacion!: string;

        constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
            this.listaalumno = new AlumnoEvaluacion();
            this.competencia = [];
            this.criterio = [];
            this.pregunta = [];
        }

        ngAfterViewInit(){
            this.abierto = true;
            if(this.tipovisualizacionpregunta == 1){
                this.cargarinfo();
            }
        }

        cargarinfo(){
            this.competencia = this.listapreguntas.competencia[this.conteocompetencia];
            if(!this.competencia){
                this.cambiarevaluacion.next();
            }
            this.criterio = this.listapreguntas.competencia[this.conteocompetencia].listacriterio[this.conteocriterio];
            if(!this.criterio){
                this.cambiarevaluacion.next();
            }
            this.pregunta = this.listapreguntas.competencia[this.conteocompetencia].listacriterio[this.conteocriterio].listapreguntas[this.conteopregunta];
            if(!this.pregunta){
                this.cambiarevaluacion.next();
            }
        }

        Guardarrespuesta(pregunta:any, seleccion:any = 0, opciones: any = 0, criterio:any = ""){
                if(this.tipovisualizacionpregunta == 2){
                    pregunta.color = "#FFFFFF";
                pregunta.contestada = true;
                if(pregunta.relacionpreguntas && pregunta.tipopreguntaid == 1){
                    if(pregunta.relacionpreguntas.length > 0){
                        let preguntasrelacionadas = pregunta.relacionpreguntas.filter((x:any)=> x.escalaevaluacionvalorid == seleccion && x.preguntapadreid == pregunta.preguntaid);
                        if(preguntasrelacionadas.length > 0){
                            for(let pregu of pregunta.relacionpreguntas){
                                let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregu.preguntaid);
                                if(indexpregunta + 1){
                                    criterio.listapreguntas.splice(indexpregunta,1);
                                }
                            }
                            let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregunta.preguntaid);
                            if(indexpregunta + 1){
                                for(let pregunta of preguntasrelacionadas){
                                    criterio.listapreguntas.splice(indexpregunta + 1,0,pregunta);
                                }
                            }
                        }else{
                            for(let pregu of pregunta.relacionpreguntas){
                                let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregu.preguntaid);
                                if(indexpregunta + 1){
                                    criterio.listapreguntas.splice(indexpregunta,1);
                                }
                            }
                        }
                    }
                }
                else{
                    if(pregunta.relacionpreguntas){
                        let preguntasrelacionadas = pregunta.relacionpreguntas.filter((x:any)=> x.preguntapadreid == pregunta.preguntaid);
                        if(preguntasrelacionadas.length > 0 && seleccion != ""){
                            for(let pregu of pregunta.relacionpreguntas){
                                let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregu.preguntaid);
                                if(indexpregunta + 1){
                                    criterio.listapreguntas.splice(indexpregunta,1);
                                }
                            }
                            let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregunta.preguntaid);
                            if(indexpregunta + 1){
                                for(let pregunta of preguntasrelacionadas){
                                    criterio.listapreguntas.splice(indexpregunta + 1,0,pregunta);
                                }
                            }
                        }else{
                            for(let pregu of pregunta.relacionpreguntas){
                                let indexpregunta = criterio.listapreguntas.findIndex((x:any)=>x.preguntaid == pregu.preguntaid);
                                if(indexpregunta + 1){
                                    criterio.listapreguntas.splice(indexpregunta,1);
                                }
                            }
                            if(seleccion == ""){
                                pregunta.contestada = false;
                            }
                        }
                    }else{
                        if(seleccion == ""){
                            pregunta.contestada = false;
                        }
                    }
                }
                }else{
                    let cantidadpregunta = this.listapreguntas.competencia[this.conteocompetencia].listacriterio[this.conteocriterio].listapreguntas.length;
                    let cantidadcriterio = this.listapreguntas.competencia[this.conteocompetencia].listacriterio.length;
                    let cantidadcompetencia = this.listapreguntas.competencia.length;
                    let info = this.conteopregunta + 1;
                    let infocriterio = this.conteocriterio + 1;
                    let infocompetencia = this.conteocompetencia + 1;
                    if(info < cantidadpregunta){
                        this.conteopregunta = this.conteopregunta + 1;
                        this.cargarinfo();
                    }else{
                        if(infocriterio < cantidadcriterio && info == cantidadpregunta){
                            this.conteocriterio = this.conteocriterio + 1
                            this.conteopregunta = 0;
                            this.cargarinfo();
                        }else{
                            if(infocompetencia < cantidadcompetencia && infocriterio == cantidadcriterio){
                                this.conteocompetencia = this.conteocompetencia + 1;
                                this.conteocriterio = 0;
                                this.conteopregunta = 0;
                                this.cargarinfo();
                            }else{
                                this.cambiarevaluacion.next()
                            }
                        }
                    }
                }
                let objetos = {"evaluacionpendienterespuestaid": pregunta.evaluacionpendienterespuestaid,"tipopreguntaid":pregunta.tipopreguntaid ,"escalaevaluacionvalorid": seleccion};
                this.guardarrespuesta.next(objetos);

        }

        GuardarComentario(e:any){
            this.comentario.next(e);
        }

        Salir(){
           if(this.tipovisualizacionpregunta == 2){
            let sincontestar = false;
            for(let competencia of this.listapreguntas){
                for(let criterio of competencia.listacriterio){
                    let preguntasincontestar = criterio.listapreguntas.filter((x:any)=>x.contestada == false);
                    if(preguntasincontestar.length > 0){
                        for(let preguntacolor of preguntasincontestar){
                            preguntacolor.color = "#FA3434";
                        }
                        sincontestar = true;
                    }
                }
            }
            if(sincontestar){
                this.sinterminar.next(sincontestar);
            }else{
                this.terminado.next(sincontestar);
            }
           }else{
            let opciones = this.sistemaService.GetOpcionesSalir();
            this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro de que quieres salir de la evaluación? <br> Si te sales se reiniciará la evaluación', opciones).then(res => {
                if (res == 1) {
                    this.salir.next();
                }
            });
           }
        }
    }